import { apiClient } from '@isocel/front-common';
import { useQuery } from 'react-query';

import { Supplier } from './types';

export const fetchSuppliers = async (): Promise<Supplier[]> => {
    const { data } = await apiClient().get(`/suppliers`);
    return (data as any[]).map((s) => ({ ...s, id: s.id || s._id } as Supplier));
};
export const useSupplierByStore = (store: string, organization?: string) => {
    return useQuery<Supplier[], Error>(['suppliers', store, organization], async () => {
        const data = await fetchSuppliers();

        const matchStore = (s: Supplier) => {
            if (!s.store) return false;
            if (typeof s.store === 'string') return s.store === store;
            return (s.store as any).id === store || (s.store as any)._id === store;
        };

        const matchOrg = (s: Supplier) => {
            if (!organization || s.store !== null) return false;
            if (typeof s.organization === 'string') return s.organization === organization;
            return (s.organization as any)?.id === organization || (s.organization as any)?._id === organization;
        };

        const storeSuppliers = data.filter(matchStore);
        const orgSuppliers = data.filter(matchOrg);

        const combinedSuppliers = [...storeSuppliers, ...orgSuppliers];

        combinedSuppliers.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

        return combinedSuppliers;
    });
};
